import React, { useEffect } from 'react';
import {
    IconType,
    PageFrame,
    ResultScreen,
    useNavigate,
} from '@alfa-retail-react/components';
import { useLocation } from 'react-router-dom';

import { ErrorPageState } from 'app/logic/pages/error/ErrorPage';
import { useApplicationContext } from 'app/store/сontext/ApplicationContext';
import { useAnalytics } from 'app/analytics/useAnalytics';

import 'app/logic/pages/error/ErrorPage.less';

const TITLE = 'Не удалось выполнить операцию';
const ERROR_MESSAGE = 'Попробуйте ещё раз позже';
const BUTTON_TEXT = 'Попробовать ещё раз';

/**
 * Страница ошибки.
 */
export const UnexpectedErrorPage = () => {
    const navigate = useNavigate();
    const applicationContext = useApplicationContext();
    const state = useLocation().state as ErrorPageState;

    const defaultActionHandler = () => {
        navigate(-1);
    };
    const onClickActionButton = state?.actionHandler || defaultActionHandler;

    const locationPathname = window.location.pathname;
    const productCode = locationPathname.split('/').pop();
    const analytics = useAnalytics(productCode, 'ErrorPage', false);

    useEffect(() => {
        analytics.pageDisplayed();
    }, []);

    return (
        <PageFrame
            rightAddonLogo={applicationContext.additionalLogo}
            displayFooter
        >
            <ResultScreen>
                <ResultScreen.Icon iconType={IconType.ERROR} />
                <ResultScreen.Header title={TITLE} />
                <ResultScreen.ContentBar messages={[ERROR_MESSAGE]} />
                <ResultScreen.ActionBar
                    actionButtons={[
                        {
                            children: BUTTON_TEXT,
                            onClick: onClickActionButton,
                            view: 'accent',
                        },
                    ]}
                />
            </ResultScreen>
        </PageFrame>
    );
};

/**
 * Путь к странице ошибки.
 */
export const UNEXPECTED_ERROR_PAGE_URL: string = '/unexpected-error';
